import { MentalStateSlug, SymptomSlug } from '@/types/shared/mentalStateEnums';

interface MoodDataPoint {
  date: string;
  averageMood: number;
}
interface SymptomData {
  symptom: SymptomSlug;
  percentage: number;
  mentalState: MentalStateSlug;
}

interface MentalState {
  state: string;
  percentage: number;
}

interface RecoveryCheckPoint {
  depression: number;
  anxiety: number;
  burnout: number;
  checkpointNumber: number;
}

interface GaugeData {
  currentLevel: number;
  range: 'low' | 'medium' | 'high';
}

interface AnalyticsData {
  mood: MoodDataPoint[] | null;
  mentalStates: MentalState[] | null;
  gauge: GaugeData | null;
  symptoms: SymptomData[] | null;
  progress: RecoveryCheckPoint[] | null;
  metrics: any;
}

export const analytics: AnalyticsData = {
  mood: [
    {
      date: '2025-04-01T00:00:00.000Z',
      averageMood: 2.4285714285714284,
    },
    {
      date: '2025-04-02T00:00:00.000Z',
      averageMood: 2.142857142857143,
    },
    {
      date: '2025-04-03T00:00:00.000Z',
      averageMood: 1.8571428571428572,
    },
    {
      date: '2025-04-04T00:00:00.000Z',
      averageMood: 2,
    },
    {
      date: '2025-04-05T00:00:00.000Z',
      averageMood: 2.2857142857142856,
    },
    {
      date: '2025-04-06T00:00:00.000Z',
      averageMood: 2.4285714285714284,
    },
    {
      date: '2025-04-07T00:00:00.000Z',
      averageMood: 2.2857142857142856,
    },
    {
      date: '2025-04-08T00:00:00.000Z',
      averageMood: 2.4285714285714284,
    },
    {
      date: '2025-04-09T00:00:00.000Z',
      averageMood: 2.857142857142857,
    },
    {
      date: '2025-04-10T00:00:00.000Z',
      averageMood: 2.4285714285714284,
    },
    {
      date: '2025-04-11T00:00:00.000Z',
      averageMood: 2.7142857142857144,
    },
    {
      date: '2025-04-12T00:00:00.000Z',
      averageMood: 3.2857142857142856,
    },
    {
      date: '2025-04-13T00:00:00.000Z',
      averageMood: 3.4285714285714284,
    },
    {
      date: '2025-04-14T00:00:00.000Z',
      averageMood: 3.4285714285714284,
    },
    {
      date: '2025-04-15T00:00:00.000Z',
      averageMood: 3.4285714285714284,
    },
    {
      date: '2025-04-16T00:00:00.000Z',
      averageMood: 3.5714285714285716,
    },
    {
      date: '2025-04-17T00:00:00.000Z',
      averageMood: 3.857142857142857,
    },
    {
      date: '2025-04-18T00:00:00.000Z',
      averageMood: 3.4285714285714284,
    },
    {
      date: '2025-04-19T00:00:00.000Z',
      averageMood: 3.2857142857142856,
    },
    {
      date: '2025-04-20T00:00:00.000Z',
      averageMood: 3.5714285714285716,
    },
    {
      date: '2025-04-21T00:00:00.000Z',
      averageMood: 3.5714285714285716,
    },
    {
      date: '2025-04-22T00:00:00.000Z',
      averageMood: 4,
    },
    {
      date: '2025-04-23T00:00:00.000Z',
      averageMood: 4,
    },
    {
      date: '2025-04-24T00:00:00.000Z',
      averageMood: 3.7142857142857144,
    },
    {
      date: '2025-04-25T00:00:00.000Z',
      averageMood: 4.285714285714286,
    },
    {
      date: '2025-04-26T00:00:00.000Z',
      averageMood: 4.142857142857143,
    },
    {
      date: '2025-04-27T00:00:00.000Z',
      averageMood: 4.142857142857143,
    },
    {
      date: '2025-04-28T00:00:00.000Z',
      averageMood: 4.285714285714286,
    },
  ],
  mentalStates: [
    {
      state: 'anxiety',
      percentage: 9.09,
    },
    {
      state: 'depression',
      percentage: 5,
    },
    {
      state: 'burnout',
      percentage: 21.36,
    },
    {
      state: 'healthy',
      percentage: 64.54,
    },
  ],
  gauge: {
    currentLevel: 22,
    range: 'low',
  },
  symptoms: [
    { symptom: SymptomSlug.EMOTIONAL_EXHAUSTION, percentage: 20, mentalState: MentalStateSlug.BURNOUT },
    { symptom: SymptomSlug.DEPERSONALIZATION, percentage: 45, mentalState: MentalStateSlug.BURNOUT },
    { symptom: SymptomSlug.REDUCED_ACCOMPLISHMENT, percentage: 55, mentalState: MentalStateSlug.BURNOUT },

    { symptom: SymptomSlug.NERVOUSNESS, percentage: 60, mentalState: MentalStateSlug.ANXIETY },
    { symptom: SymptomSlug.UNCONTROLLABLE_WORRY, percentage: 10, mentalState: MentalStateSlug.ANXIETY },
    { symptom: SymptomSlug.EXCESSIVE_WORRY, percentage: 55, mentalState: MentalStateSlug.ANXIETY },
    { symptom: SymptomSlug.INABILITY_RELAX, percentage: 26, mentalState: MentalStateSlug.ANXIETY },
    { symptom: SymptomSlug.RESTLESSNESS, percentage: 75, mentalState: MentalStateSlug.ANXIETY },
    { symptom: SymptomSlug.IRRITABILITY, percentage: 15, mentalState: MentalStateSlug.ANXIETY },
    { symptom: SymptomSlug.FEAR, percentage: 35, mentalState: MentalStateSlug.ANXIETY },

    { symptom: SymptomSlug.APPETITE_CHANGE, percentage: 81, mentalState: MentalStateSlug.DEPRESSION },
    { symptom: SymptomSlug.GUILT_FEELINGS, percentage: 20, mentalState: MentalStateSlug.DEPRESSION },
    { symptom: SymptomSlug.CONCENTRATION_DIFFICULTY, percentage: 50, mentalState: MentalStateSlug.DEPRESSION },
    { symptom: SymptomSlug.PSYCHOMOTOR_CHANGE, percentage: 10, mentalState: MentalStateSlug.DEPRESSION },
    { symptom: SymptomSlug.SUICIDAL_THOUGHTS, percentage: 34, mentalState: MentalStateSlug.DEPRESSION },
    { symptom: SymptomSlug.DEPRESSED_MOOD, percentage: 66, mentalState: MentalStateSlug.DEPRESSION },
    { symptom: SymptomSlug.INTEREST_LOSS, percentage: 18, mentalState: MentalStateSlug.DEPRESSION },
    { symptom: SymptomSlug.FATIGUE, percentage: 25, mentalState: MentalStateSlug.DEPRESSION },
    { symptom: SymptomSlug.INSOMNIA, percentage: 40, mentalState: MentalStateSlug.DEPRESSION },
  ],
  progress: [
    {
      anxiety: 4,
      depression: 3,
      burnout: 2,
      checkpointNumber: 1,
    },
    {
      anxiety: 4,
      depression: 2.5,
      burnout: 3.6,
      checkpointNumber: 2,
    },
    {
      anxiety: 2.3,
      depression: 2.8,
      burnout: 1.9,
      checkpointNumber: 3,
    },
    {
      anxiety: 3,
      depression: 3.1,
      burnout: 1,
      checkpointNumber: 4,
    },
    {
      anxiety: 2.2,
      depression: 1.5,
      burnout: 1.1,
      checkpointNumber: 5,
    },
    {
      anxiety: 0,
      depression: 1.2,
      burnout: 0.7,
      checkpointNumber: 6,
    },
  ],
  metrics: {
    registeredUsers: 879,
    activeUsers: 747,
    helpRequests: 87,
    usersInCriticalState: 32,
  },
};
